import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';

@Injectable({
  providedIn: 'root'
})
export class TransactionRequirementItemServiceService extends BaseProvider {
	fileToLoad: any;
	requirementData:any;

	requirementItem: any = {};
  	constructor(  		
		public globals: GlobalsService,
 		public http: HttpClient,	
  	) { 
		super();

		this.baseUrl = "userProcessRequirementService";
	}

	getByParams(params){
	    return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 
					   this.baseUrl + 
					   '/requirement' +
					   `?requirementId=${params.requirementId}` + 
					   `&ProcessId=${params.processId}`;

	        this.http
	        .get(
	          this.url
	        )
	        .subscribe(
	            (data: any) => {
					this.requirementData = data;
	                resolve(data);
					
	            },
	            err => {reject(err)}
	        );
	    }); 		
	}	

	get(requirementId){
	    return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 
					   this.baseUrl + `?requirementId=${requirementId}`;

	        this.http
	        .get(
	          this.url
	        )
	        .subscribe(
	            (data: any) => {
					// this.requirementData = data;
	                resolve(data);
					
	            },
	            err => {reject(err)}
	        );
	    }); 		
	}	

	execute(requirementId){
	    return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 
					   this.baseUrl + `/${requirementId}`;

	        this.http
	        .post(
	          this.url,
	          null
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data);
	            },
	            err => {reject(err)}
	        );
	    }); 		
	}

	uploadRequirementFile(params){
	    return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/file';

	        this.http
	        .post(
	          this.url, 
	          params
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data.Data);
	            },
	            err => {reject(err)}
	        );
	    });   		
	}			

	/**
	 * Limpia todos los datos relacionados con los items de requisitos
	 * Se llama cuando se abandona el componente transaction-management
	 */
	clearRequirementItemData() {
		this.fileToLoad = null;
		this.requirementData = null;
		this.requirementItem = {};
		
		console.log('TransactionRequirementItemServiceService: datos limpiados');
	}
}
